import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  fetchPaymentInfo,
  resetSavedPaymentInfo,
  updateBillingAddress,
  updateCardNumber,
  updateExpirationMonth,
  updateExpirationYear,
  updateFullName,
  updatePaymentInfo
} from 'actions/account/payment';
import { firePixelServer } from 'actions/pixelServer';
import { fetchShippingInfo } from 'actions/account/shipping';
import BackNav from 'components/account/BackNav';
import AccountHeader from 'containers/account/AccountHeader';
import Breadcrumb from 'components/account/Breadcrumb';
import PaymentForm from 'components/account/PaymentForm';
import SiteAwareMetadata from 'components/SiteAwareMetadata';
import { PageLoader } from 'components/Loader';
import styles from 'styles/containers/account/editPayment.scss';

const items = [
  { name: 'Payment Information', url: '/payments' },
  { name: 'Edit Payment Method' }
];

export class EditPayment extends Component {
  componentDidMount() {
    const { firePixelServer, payment: { paymentInstrumentId }, shipping: { addresses } } = this.props;

    if (!paymentInstrumentId || !addresses) {
      this.fetchData();
    }

    firePixelServer('my-account', {}, 'payment-edit');
  }

  componentWillUnmount() {
    const { resetSavedPaymentInfo } = this.props;
    resetSavedPaymentInfo();
  }

  fetchData() {
    const { fetchShippingInfo, fetchPaymentInfo, params: { paymentId } } = this.props;
    const returnTo = `/payments/${paymentId}/edit`;
    fetchPaymentInfo(paymentId, returnTo);
    fetchShippingInfo(null, returnTo);
  }

  render() {
    const {
      shipping,
      payment,
      updateFullName,
      updateCardNumber,
      updateBillingAddress,
      updateExpirationMonth,
      updateExpirationYear,
      updatePaymentInfo
    } = this.props;
    const { paymentInstrumentId } = payment;
    const { addresses, isLoading } = shipping;

    if (!paymentInstrumentId || !addresses || isLoading) {
      return <PageLoader centered={true}/>;
    }

    return (
      <SiteAwareMetadata>
        <div className={styles.editPayment}>
          <BackNav to="/payments">Manage Payments</BackNav>
          <Breadcrumb items={items}/>
          <AccountHeader title="Edit Payment" showCustomerEmail={false}/>
          {addresses.length ? (
            <PaymentForm
              payment={payment}
              addresses={addresses}
              onUpdateFullName={updateFullName}
              onUpdateCardNumber={updateCardNumber}
              onUpdateBillingAddress={updateBillingAddress}
              onUpdateExpirationMonth={updateExpirationMonth}
              onUpdateExpirationYear={updateExpirationYear}
              onUpdatePaymentInfo={updatePaymentInfo}/>
          ) : (
            <p>Please add a billing address before you edit a payment method.</p>
          )}
        </div>
      </SiteAwareMetadata>
    );
  }
}

const mapStateToProps = state => ({
  payment: state.payment,
  shipping: state.shipping
});

export default connect(mapStateToProps,{
  fetchPaymentInfo,
  fetchShippingInfo,
  firePixelServer,
  resetSavedPaymentInfo,
  updateFullName,
  updateCardNumber,
  updateExpirationMonth,
  updateExpirationYear,
  updateBillingAddress,
  updatePaymentInfo
})(EditPayment);
